// extracted by mini-css-extract-plugin
module.exports = {"static":"q_B","map":"q_C"};